export const navigationGroups = [
  { id: 'bills', label: 'Bills', links: [] },
  {
    id: 'action',
    label: 'Take action',
    links: [
      { to: '/legislator-meetings', label: 'Legislator meetings' },
      { to: '/legislator-lookup', label: 'Find your legislators' },
      { to: '/join-the-team', label: 'Join the movement' },
      { to: '/commemorative-coins', label: 'Commemorative coins' },
    ],
  },
  {
    id: 'about',
    label: 'About',
    links: [
      { to: '/about-robert-garza', label: 'About Robert Garza' },
      { to: '/schedule-consultation', label: 'Schedule a personal case review' },
      { to: '/faq', label: 'Frequently asked questions' },
    ],
  },
] as const;
